import { sendUpdateRecommendedResource } from "redux/sagas/updateRecommendedResourceSaga";
import {
  calculateScoresFromCheckInAnswers
} from "components/checkIn/questionnaire/AssessmentScoreUtility";
import { useDispatch, useSelector } from "react-redux";
import { selectAnswers } from "redux/checkIn/selectors";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

export default function useRedirectToResults() {
  const answers = useSelector(selectAnswers);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useCallback(() => {
    dispatch(sendUpdateRecommendedResource(calculateScoresFromCheckInAnswers(answers)));
    navigate('/results');
  }, [dispatch, answers, navigate])
}